import { render } from "./CreateNetwork.vue?vue&type=template&id=4afb8348&scoped=true"
import script from "./CreateNetwork.vue?vue&type=script&lang=js"
export * from "./CreateNetwork.vue?vue&type=script&lang=js"

import "./CreateNetwork.vue?vue&type=style&index=0&id=4afb8348&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4afb8348"]])

export default __exports__